// extracted by mini-css-extract-plugin
export default {"submit":"WygTch9qDuerfTYHNUye","resetCard":"lMDSmWJaNNK2Pnz6SbhL"};